import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getRoutesByEventIdAsync, createRouteAsync, updateRouteAsync, deleteRouteAsync, getRouteByIdAsync } from './transportRouteThunk';
const initialState = {
    status: APIStatus.IDLE,
    routes: null,
    route: undefined,
    routeDetail: undefined
};
export const transportRouteSlice = createSlice({
    name: 'transportRoute',
    initialState,
    reducers: {
        resetTransportRouteStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoutesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRoutesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.routes = action.payload;
        })
            .addCase(getRoutesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createRouteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createRouteAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.route = action.payload;
        })
            .addCase(createRouteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateRouteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateRouteAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.routes) {
                state.routes.items = state.routes.items.map((r) => r.id === action.payload.id ? action.payload : r);
            }
            state.route = action.payload;
        })
            .addCase(updateRouteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteRouteAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteRouteAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteRouteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getRouteByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRouteByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.routeDetail = action.payload;
        })
            .addCase(getRouteByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetTransportRouteStatus } = transportRouteSlice.actions;
export default transportRouteSlice.reducer;
